// extracted by mini-css-extract-plugin
module.exports = {"question":"style_question__2IbUP","invalidValue":"style_invalidValue__3MIG1"};